import { render, staticRenderFns } from "./SurveyPackage.vue?vue&type=template&id=ef23ddb6&"
import script from "./SurveyPackage.vue?vue&type=script&lang=js&"
export * from "./SurveyPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports